export default {
  root: {
    padding: '24px 16px',
    textAlign: 'center',
    fontSize: '18px',
    width: 'calc(80% - 32px)',
    margin: '0 auto',
  },
};
